/**
 * Returns the sum/total for an array of numbers
 */
const total = (arr: number[]) => arr.reduce((a, b) => a + b);
export default total;
